import { __awaiter, __generator } from "tslib";
import { roundNotificationKey } from '.';
export var createRoundNotificationDriver = function (wrapper) {
    var base = wrapper.$("." + roundNotificationKey);
    return {
        getCountText: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.$('.count').text()];
        }); }); },
        count: function () { return __awaiter(void 0, void 0, void 0, function () {
            var count;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, base.$('.count').text()];
                    case 1:
                        count = _a.sent();
                        return [2 /*return*/, parseInt(count, 10)];
                }
            });
        }); },
        hasIcon: function () { return base.$('.icon').exists(); },
        hasCount: function () { return base.$('.count').exists(); },
        hasDot: function () { return base.$('.dot').exists(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map